import React from "react";
import "./ActorsSection.scss";

import {
  FiUser,
  FiHeart,
  FiHome,
  FiBookOpen,
  FiShield,
} from "react-icons/fi";

const actors = [
  {
    icon: <FiUser />,
    title: "Femmes candidates",
    description:
      "Un portail personnel pour s'orienter, suivre sa formation et communiquer avec l'assistant social et le formateur.",
  },
  {
    icon: <FiHeart />,
    title: "Assistants sociaux",
    description:
      "Un tableau de bord pour accueillir la femme, l'aider à remplir le formulaire et assurer le suivi socio-professionnel.",
  },
  {
    icon: <FiHome />,
    title: "Associations",
    description:
      "Un dashboard pour consulter les dossiers, sélectionner les candidates et affecter un formateur.",
  },
  {
    icon: <FiBookOpen />,
    title: "Formateurs",
    description:
      "Un espace pour dispenser la formation, évaluer les progrès et documenter les résultats.",
  },
  {
    icon: <FiShield />,
    title: "Administration",
    description:
      "Gestion des utilisateurs, suivi des indicateurs, reporting national et administration de la plateforme.",
  },
];

const ActorsSection = () => {
  return (
    <section className="actors-section">
      <div className="container">

        <div className="section-title">
          <h2>Une plateforme pour chaque acteur du parcours</h2>
        </div>

        <div className="actors-grid">

          {actors.map((actor, index) => (
            <div className="actor-card" key={index}>

              <div className="actor-icon">
                {actor.icon}
              </div>

              <h3>{actor.title}</h3>

              <p>{actor.description}</p>

            </div>
          ))}

        </div>

      </div>
    </section>
  );
};

export default ActorsSection;